import Cookies from 'js-cookie'

if( window.ie11_redirect && window.ie11_redirect != '' && window.navigator.userAgent.match(/(MSIE|Trident)/) ){

    let ie11_cookie = Cookies.get('ie11_already_redirected')

    if( ie11_cookie != 'yes' ){
        window.location.href = window.ie11_redirect
        Cookies.set('ie11_already_redirected','yes');
    }

}
